import {Branch, Lookup} from "../../models/country";

export const DeliveryBranches: Branch[] = [
  {
    id: "Adi-Keyih",
    label: "Adi-Keyih",
    value: "Adi-Keyih",
    index: 0,
    key: "Adi-Keyih",
    zoba:'Debub'
  },
  {
    id: "Mendefera",
    label: "Mendefera",
    value: "Mendefera",
    index: 1,
    key: "Mendefera",
    zoba:'Debub'
  },
  {
    id: "Asmara",
    label: "Asmara",
    value: "Asmara",
    index: 2,
    key: "Asmara",
    zoba:'MAEKEL'
  },
  {
    id: "Barentu",
    label: "Barentu",
    value: "Barentu",
    index: 3,
    key: "Barentu",
    zoba:'Gash Barka'
  },
  {
    id: "Dekemhare",
    label: "Dekemhare",
    value: "Dekemhare",
    index: 4,
    key: "Dekemhare",
    zoba:'Debub'
  },
  {
    id: "Kerren",
    label: "Kerren",
    value: "Kerren",
    index: 5,
    key: "Kerren",
    zoba:'Anseba'
  },
  {
    id: "Massawa",
    label: "Massawa",
    value: "Massawa",
    index: 6,
    key: "Massawa",
    zoba:'Semenawi Keyih Bahri'
  },
  {
    id: "Tesseney",
    label: "Tesseney",
    value: "Tesseney",
    index: 7,
    key: "Tesseney",
    zoba:'Gash Barka'
  },
  {
    id: "Akurdet",
    label: "Akurdet",
    value: "Akurdet",
    index: 8,
    key: "Akurdet",
    zoba:'Gash Barka'
  },
  {
    id: "Assab",
    label: "Assab",
    value: "Assab",
    index: 9,
    key: "Assab",
    zoba:'Debubawi Keyih Bahri'
  },
  {
    id: "Dubarwa",
    label: "Dubarwa",
    value: "Dubarwa",
    index: 10,
    key: "Dubarwa",
    zoba:'Debub'
  },
  {
    id: "Ghindae",
    label: "Ghindae",
    value: "Ghindae",
    index: 11,
    key: "Ghindae",
    zoba:'Semenawi Keyih Bahri'
  },
];
